module.exports = __webpack_public_path__ + "static/media/cardplank.df77bf5f.webp";